import type { OperationPackageInstancesResponse } from '@/features/operation-packages/api';
import type { ApplicationInstanceRow } from './type';
type ApiInstanceRow = OperationPackageInstancesResponse['items'][number];

/** BOE instances の 1 行を申請パッケージ一覧行へ変換する */
export function mapApplicationInstanceToRow(row: ApiInstanceRow): ApplicationInstanceRow {
  return {
    id: row.id,
    instanceId: row.id,
    target: {
      targetName: row.target.targetName,
      targetAvatarUrl: row.target.targetAvatarUrl
    },
    anchorDate: row.anchorDate,
    progress: {
      completed: row.completedOperationStepCount,
      total: row.totalOperationStepCount
    }
  };
}